import { api } from '../lib/api'

export type ClientOfferListItem = {
  offer_id: number
  job_id: number
  pro: {
    handle?: string
    name?: string
    avatar_url?: string
  }
  amount_pixe?: string
  amount_pixe_atomic?: number
  approx_usd?: string
  title: string
  status: string
  sent_at?: string | null
}

export type ClientOfferDetail = {
  offer_id: number
  status: string
  sent_at?: string | null
  accepted_at?: string | null
  amount_pixe?: string
  amount_pixe_atomic?: number
  approx_usd?: string
  description: string
  job: {
    id: number
    title?: string
    description?: string
    location?: string | null
    mode?: string | null
    budget_hint?: string | null
    created_at?: string
  }
  pro: {
    handle?: string
    name?: string
    avatar_url?: string
  }
  deposit_required: boolean
  deposit_pixe?: string
  deposit_pixe_atomic?: number
  deposit_approx_usd?: string
}

export async function listClientOffers(): Promise<{ results: ClientOfferListItem[] }> {
  const { data } = await api.get('/api/client/offers/')
  return data
}

export async function getClientOffer(offerId: number | string): Promise<ClientOfferDetail> {
  const { data } = await api.get(`/api/client/offers/${offerId}/`)
  return data
}

export async function acceptClientOffer(offerId: number | string): Promise<{
  job_id: number
  escrow_required: boolean
  deposit_pixe: string
  deposit_pixe_atomic: number
}> {
  const { data } = await api.post(`/api/client/offers/${offerId}/accept/`, {})
  return data
}
